/* @ngInject */
const format = (utils) => {
  const self = {}

  self.user = (_railway) => {
    return _railway
  }

  self.server = (_railway) => {
    const railway = utils.copy(_railway)

    railway.length = railway.length.toString().replace(/,/g, '.')

    return railway
  }

  return self
}

export default format



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/services/format.service.js